import { FC, ReactNode, useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import {
  MplusStatuses,
  MplusStatusesTypes,
} from 'widgets/mplus/mplus-payment/module'

import { MplusPopup } from 'entities/mplus/ui/mplus-popup'

import { priceShow } from 'shared/lib/priceShow'
import { Button } from 'shared/ui/button'
import { CheckBox } from 'shared/ui/check-box'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import { MplusLimit } from '../components/mplus-limit'

import {
  // MplusConfirm,
  MplusConfirmForNotAvailable,
} from './components/mplus-confirm'
import { MplusDetail } from './components/mplus-detail'
import { SelectPaymentDate } from './components/select-payment-date'
import { MplusPopUps, MplusPopUpsTypes } from './model'
import s from './styles.module.scss'

interface Props {
  limitMplus?: string
  confirmComponent?: ReactNode
  mplusStatus?: MplusStatusesTypes
  mplusCreditInfo?: {
    moneyPayNow?: string
    creditMoneyEachMonth?: string
    countPassengers?: number
    eachPassengerPayInfo?: string
  }
  onSubmit?: (dayInMonth: number) => void
}

export interface ConfirmMplus {
  day?: number
  isConfirmed?: boolean
  isConfirmPurchase?: boolean
}

export const MplusActive: FC<Props> = ({
  limitMplus,
  mplusStatus,
  mplusCreditInfo,
  confirmComponent,
  onSubmit,
}) => {
  const { t } = useTranslation()

  const [confirm, setConfirm] = useState<ConfirmMplus>({
    isConfirmPurchase: !Boolean(confirmComponent),
    isConfirmed: true,
  })

  const { openDialog } = useDialogBottomSheet()

  const showPopUpInfo = (typeInfo: MplusPopUpsTypes) => {
    const { title, description } = MplusPopUps[typeInfo]

    openDialog({
      child: (
        <MplusPopup
          title={t(title)}
          description={t(description, {
            price: priceShow(String(mplusCreditInfo?.creditMoneyEachMonth)),
          })}
        />
      ),
      isDialog: false,
    })
  }

  const onSubmitHandler = () => {
    if (confirm?.day) {
      onSubmit?.(confirm?.day)
    }
  }

  return (
    <div className={s.container}>
      <div
        className={clsx(
          mplusStatus === MplusStatuses.ALLOW.key ? s.limit : s.limitLow,
        )}
      >
        <MplusLimit
          limit={limitMplus || '0'}
          hasLimit={mplusStatus === MplusStatuses.ALLOW.key}
          onShowDetail={(hasLimit) => {
            showPopUpInfo(
              hasLimit
                ? MplusPopUps.availableInfo.key
                : MplusPopUps.unavailableInfo?.key,
            )
          }}
        />
      </div>

      {mplusStatus === MplusStatuses.ALLOW.key && (
        <div className={s.detail}>
          <MplusDetail
            {...mplusCreditInfo}
            showPayInfo={() => showPopUpInfo(MplusPopUps.eachMonthPayInfo.key)}
            showCashbackInfo={() => showPopUpInfo(MplusPopUps.cashback.key)}
          />
        </div>
      )}

      {mplusStatus === MplusStatuses.ALLOW.key && (
        <div className={s.paymentWrapper}>
          <SelectPaymentDate
            currentDate={confirm?.day}
            onChange={(value) => {
              setConfirm((data) => ({ ...data, day: value }))
            }}
            onShowDetailPaymentDays={() =>
              showPopUpInfo(MplusPopUps.witchDayPayInfo.key)
            }
          />
        </div>
      )}

      {mplusStatus === MplusStatuses.ALLOW.key && (
        <>
          {/* 
            <MplusConfirm
              isConfirmed={Boolean(confirm?.isConfirmed)}
              onConfirm={(value) => {
                setConfirm((data) => ({ ...data, isConfirmed: value }))
              }}
            /> 
          */}

          {confirmComponent && (
            <div className={s.confirmCheck}>
              <CheckBox
                isChecked={confirm?.isConfirmPurchase}
                onClick={(value) => {
                  setConfirm((data) => ({ ...data, isConfirmPurchase: value }))
                }}
              />
              {confirmComponent}
            </div>
          )}

          <Button
            disabled={
              !Boolean(
                confirm?.day &&
                confirm?.isConfirmed &&
                confirm?.isConfirmPurchase,
              )
            }
            onClick={onSubmitHandler}
          >
            <span className={'bold-16'}>{t('mplus.arrange')}</span>
          </Button>
        </>
      )}

      {mplusStatus !== MplusStatuses.ALLOW.key && (
        <MplusConfirmForNotAvailable />
      )}
    </div>
  )
}
